import React from 'react';
import './generate-pdf-content.scss';
import { PNGS, SVGS } from '../../assets';
import { CommonButton } from '../../components';
import { useGeneratePdfContent } from './use-generate-pdf-content';
import Lottie from 'lottie-react';
import loadingAnimation from '../../assets/lottie-loader.json';
import { handleShare } from '../../helper';
import { ReactComponent as DownloadIcon } from '@zonofi/svg-icons/download.svg';

interface GeneratePDFContentProps {
  generatePdfApiResponse: any;
  onRetry: () => void;
  onClose: () => void;
}

export const GeneratePDFContent: React.FC<GeneratePDFContentProps> = ({
  generatePdfApiResponse,
  onRetry,
  onClose,
}) => {
  const { downloading, copied, setCopied, handleDownloadPdf, blobObj } =
    useGeneratePdfContent(generatePdfApiResponse);

  return (
    <div className="generate-pdf-content">
      {!generatePdfApiResponse?.isSuccess &&
        generatePdfApiResponse?.isLoading &&
        !generatePdfApiResponse?.error && (
          <div className="generate-pdf-content-loading-container">
            <div className="generate-pdf-content-loading-container-image">
              <Lottie
                animationData={loadingAnimation}
                loop={true}
                width={197}
                height={197}
              />
            </div>
            <span className="generate-pdf-content-loading-container-info-title font-semibold">
              Pdf is generating, please wait...
            </span>
          </div>
        )}
      {!generatePdfApiResponse?.isLoading && generatePdfApiResponse?.error && (
        <div className="generate-pdf-content-loading-container">
          <div className="generate-pdf-content-loading-container-image">
            <img
              src={PNGS.Failed}
              alt="failed to generate pdf icon"
              width={200}
              height={200}
            />
          </div>
          <div className="generate-pdf-content-loading-container-info">
            <span className="generate-pdf-content-loading-container-info-title font-semibold">
              PDF generation failed!
            </span>
            <span className="generate-pdf-content-loading-container-info-description font-semibold">
              You can retry generating the PDF.
            </span>
            <CommonButton
              text="Retry"
              onPress={onRetry}
              startIcon={SVGS.Retry}
              buttonStyle="generate-pdf-content-success-container-link-btn primary-bg font-semibold"
              textStyle="primary-txt"
            />
          </div>
        </div>
      )}
      {!generatePdfApiResponse?.isLoading &&
        generatePdfApiResponse?.isSuccess &&
        generatePdfApiResponse?.data && (
          <div className="generate-pdf-content-success-container">
            <div className="generate-pdf-content-success-container-image">
              <img
                src={SVGS.SuccesIcon}
                alt="generate-pdf-response-success"
                width={120}
                height={120}
              />
            </div>
            <div className="generate-pdf-content-success-container-info">
              <span className="generate-pdf-content-success-container-info-title font-semibold">
                PDF has been Generated Successfully!
              </span>
              <span className="generate-pdf-content-success-container-info-description font-regular">
                Pdf Generated successfully, download to view the contents
              </span>
            </div>
            <div className="generate-pdf-content-success-container-link">
              <div className="generate-pdf-content-success-container-link-container font-regular">
                <span className="generate-pdf-content-success-container-link-container-link">
                  {generatePdfApiResponse?.data}
                </span>
                <div
                  className="generate-pdf-content-success-container-link-container-image"
                  onClick={() => {
                    navigator.clipboard.writeText(generatePdfApiResponse?.data);
                    setCopied(true);
                    setTimeout(() => {
                      setCopied(false);
                    }, 2000);
                  }}
                >
                  {!copied && (
                    <img
                      src={SVGS.CopyIcon}
                      alt="copy link button"
                      width={20}
                      height={20}
                    />
                  )}
                  {copied && (
                    <span className="generate-pdf-content-success-container-link-container-text font-regular">
                      Copied!
                    </span>
                  )}
                </div>
              </div>
              <CommonButton
                onPress={() =>
                  blobObj &&
                  handleShare(blobObj, 'product_catalogue.pdf', [onClose])
                }
                buttonStyle="generate-pdf-content-success-container-link-btn primary-bg font-semibold"
                text="Share"
                textStyle="primary-txt"
                startIcon={SVGS.Share}
              />
              <CommonButton
                onPress={() =>
                  handleDownloadPdf(
                    generatePdfApiResponse?.data,
                    'product_catalogue.pdf'
                  )
                }
                buttonStyle="generate-pdf-content-success-container-link-btn secondary-bg font-semibold"
                text="Download"
                textStyle="secondary-txt"
                startIcon={
                  <DownloadIcon color="black" width={20} height={20} />
                }
                loading={downloading}
              />
            </div>
          </div>
        )}
    </div>
  );
};
